import { connect } from "react-redux";
import React from 'react';
import { Box, Table, Text, Heading, VStack } from '@chakra-ui/react';

import OrganizationTicketsOutcomeChart from "../charts/OrganizationTicketsOutcomeChart";
import ReportDataTable from "../../reports/ReportDataTable";
import { TICKET_SUMMARY_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const { formatNumber } = require('../../../store/helpers');

export const renderTicketSummaryCell = (row, columnId) => {
  if (columnId === "scopeName") return row.scopeName || row.name;
  if (columnId === "total") return formatNumber(row.total);
  if (columnId === "average") return formatNumber(row.average ?? row.averageTicketsPerDay);
  if (columnId === "min") return formatNumber(row.min ?? row.minTicketsPerDay);
  if (columnId === "max") return formatNumber(row.max ?? row.maxTicketsPerDay);
  if (columnId === "completed") return formatNumber(row.completed ?? row.totalCompleted);
  if (columnId === "noShow") return formatNumber(row.noShow ?? row.totalNoShow);
  if (columnId === "unattended") return formatNumber(row.unattended ?? row.totalUnattended);
  return null;
};

const AllTicketsTable = ({
  table,
  chart,
  renderConfig,
  onRenderConfigChange,
}) => { 
  if (!renderConfig?.charts?.enabled) {
    return (
      <Box mt={10} className="ticketSummaryBlock">
        <ReportDataTable
          columns={TICKET_SUMMARY_COLUMN_DEFINITIONS}
          rows={table.map((row) => ({ ...row, scopeName: row.name || "Entire Organization" }))}
          renderConfig={renderConfig}
          renderCell={renderTicketSummaryCell}
          onSortChange={(sort) => onRenderConfigChange?.({ ...renderConfig, sort })}
        />
      </Box>
    );
  }

  return (
    <Box mt={10}>
      
      <Box>
        {
          table.map( (a, i) => 
          <Box className="reportContainer" key={i}>
            <Box mb="20px" mt="30px">
            <Heading fontSize="24px" color="#222" fontWeight="600">{i+1}. {a.name}</Heading>
            </Box>
            <Table.Root className="stripedTable" size="sm">
              <Table.Header>
                <Table.Row>
                  <Table.ColumnHeader borderRight="1px solid #dadce0">Total Tickets</Table.ColumnHeader>
                  <Table.ColumnHeader>Avg /day.</Table.ColumnHeader>
                  <Table.ColumnHeader>Min.</Table.ColumnHeader>
                  <Table.ColumnHeader borderRight="1px solid #dadce0">Max</Table.ColumnHeader>
                  <Table.ColumnHeader>Completed</Table.ColumnHeader>
                  <Table.ColumnHeader>No Show</Table.ColumnHeader>
                  <Table.ColumnHeader>Unattended</Table.ColumnHeader>
                </Table.Row>
              </Table.Header>
              <Table.Body>

                <Table.Row>
                  <Table.Cell borderRight="1px solid #dadce0">
                    <Text color={'var(--blue)'}>{formatNumber(a.total)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatNumber(a.averageTicketsPerDay)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatNumber(a.minTicketsPerDay)}</Text>
                  </Table.Cell>
                  <Table.Cell borderRight="1px solid #dadce0">
                    <Text>{formatNumber(a.maxTicketsPerDay)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <VStack>
                      <Text color={'var(--green)'}>
                        {formatNumber(a.completed)}
                      </Text>
                      <Box color='gray.500' fontWeight='semibold' fontSize='xs' textTransform='uppercase'>({a.pctCompleted.toFixed(2)}%)</Box>
                    </VStack>
                  </Table.Cell>
                  <Table.Cell>
                    <VStack>
                      <Text cursor="pointer" color={'var(--red)'}>
                        {formatNumber(a.noShow)} 
                      </Text>
                      <Box color='gray.500' fontWeight='semibold' fontSize='xs' textTransform='uppercase'>({a.pctNoShow.toFixed(2)}%)</Box>
                    </VStack>
                  </Table.Cell>
                  <Table.Cell>
                    <VStack>
                      <Text color={'var(--red)'}>
                        {formatNumber(a.unattended)} 
                      </Text>
                      <Box color='gray.500' fontWeight='semibold' fontSize='xs' textTransform='uppercase'>({a.pctUnattended.toFixed(2)}%)</Box>
                    </VStack>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell colSpan={9} p={0}>
                    <Box mt="20px" mb="20px">
                      <OrganizationTicketsOutcomeChart
                        title="Entire Organization Ticket Outcomes, Day by Day"
                        chart={chart}
                        chartHeight="320px"
                      />
                    </Box>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
              
            </Table.Root>
          </Box>
          )
        }
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
    const { defaultReducer } = state
    return {
      tickets: defaultReducer.tickets,
    };
};
export default connect(mapStateToProps, {})(
    AllTicketsTable
);
